import React, {useState} from "react";
import Button from '@mui/material/Button';
import { TextFamChol } from "./TextFamChol";
import { SourcesFamChol } from "./SourcesFamChol";
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";

export default function Fam() {

  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true);};
  const handleClose = () => {setOpen(false);};

return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Familiar Hypercholesterol' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Familiar Hypercholesterol - Variants'

        content={<TextFamChol />}

        sources={<SourcesFamChol />}

/>

</>
)}